/**
 * ============================================================================
 * @fileoverview
 * Zod 校验 Schema - 集成计划 (Integrated Plans)
 *
 * @description
 * 本文件为与 `integrated-plans` 功能相关的 API 请求数据提供 Zod 校验 schema。
 * 这些 schema 用于在 Presentation Layer (Controllers/Routes) 对传入的请求
 * (如 query parameters, body) 进行类型检查和结构验证，确保数据的安全性和一致性。
 * ============================================================================
 */
import { z } from 'zod';
// ============================================================================
// Zod Schemas
// ============================================================================
/**
 * @description `GET /api/integrated/plans/:planType` 请求的校验 schema
 *              用于验证 URL query parameter。
 */
export const getPlanRequestSchema = z.object({
    planType: z.enum(['free', 'plus', 'pro'], {
        required_error: 'planType is required.',
        invalid_type_error: "planType must be one of 'free', 'plus', or 'pro'.",
    }),
});
/**
 * @description `GET /api/integrated/plans/upgradeable` 请求的校验 schema
 *              用于验证 URL query parameter。
 */
export const getUpgradeablePlansRequestSchema = z.object({
    currentPlan: z.enum(['free', 'plus', 'pro'], {
        required_error: 'currentPlan is required.',
        invalid_type_error: "currentPlan must be one of 'free', 'plus', or 'pro'.",
    }),
});
/**
 * @description `POST /api/integrated/subscription/upgrade` 请求的校验 schema
 *              用于验证 request body。
 */
export const subscriptionUpgradeRequestSchema = z.object({
    planType: z.enum(['free', 'plus', 'pro'], {
        required_error: 'planType is required.',
        invalid_type_error: "planType must be one of 'free', 'plus', or 'pro'.",
    }),
    referralCode: z.string().optional(),
});
/**
 * @description `POST /api/integrated/coupon-activation/activate` 请求的校验 schema
 *              用于验证 request body。
 */
export const couponActivationRequestSchema = z.object({
    couponId: z
        .string({
        required_error: 'couponId is required.',
    })
        .min(1, 'couponId cannot be empty.'),
});
/**
 * @description `POST /api/integrated/user-initialization/initialize` 请求的校验 schema
 *              用于验证 request body。
 */
export const userInitializationRequestSchema = z.object({});
/**
 * @description `POST /api/integrated/subscription/renewal` 请求的校验 schema
 *              用于验证 request body。
 */
export const subscriptionRenewalRequestSchema = z.object({});
/**
 * @description `POST /api/integrated/subscription/reset-to-free` 请求的校验 schema
 *              用于验证 request body。
 */
export const subscriptionResetRequestSchema = z.object({});
// ============================================================================
// TypeScript 类型推断 (Inferred Types)
// ============================================================================
// 遵循 auth 包的模式，此文件只导出 Zod schema。
// 相关的 TypeScript 类型应在 *.types.ts 文件中手动定义。
//# sourceMappingURL=integration.schemas.js.map